import React from 'react';
import { ArrowRightLeftIcon } from 'lucide-react';
import { SubstitutionPreference, useStore } from '../../lib/store';
const options: {
  id: SubstitutionPreference;
  label: string;
  description: string;
}[] = [{
  id: 'allow',
  label: 'Best available substitute',
  description: 'A similar item is chosen to keep your order on time.'
}, {
  id: 'contact',
  label: 'Contact me first',
  description: 'We will ask before replacing an unavailable item.'
}, {
  id: 'cancel',
  label: 'Remove unavailable items',
  description: 'Continue the order without unavailable items.'
}];
export function NowSubstitutionPreference() {
  const preference = useStore(state => state.substitutionPreference);
  const setPreference = useStore(state => state.setSubstitutionPreference);
  return <section className="rounded-xl border border-brand-border bg-white p-4" aria-labelledby="substitution-heading" data-id="element-4310" data-mp="3sanw1d09k3c2">
      <div className="flex items-start gap-2" data-id="element-4311" data-mp="1436xytrr5ho">
        <ArrowRightLeftIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-4312" data-mp="13uycj4oimca" />
        <div data-id="element-4313" data-mp="osa34nt7ieyt">
          <h2 id="substitution-heading" className="text-sm font-bold text-brand-ink" data-id="element-4314" data-mp="ovxwnmynj1dj">If an item becomes unavailable</h2>
          <p className="mt-1 text-xs leading-4 text-brand-muted" data-id="element-4315" data-mp="xujax5x3bu8i">Choose how our pharmacist should handle a suitable alternative.</p>
        </div>
      </div>
      <fieldset className="mt-3 space-y-2" data-id="element-4316" data-mp="tu93dotngvrj">
        <legend className="sr-only" data-id="element-4317" data-mp="63d82hpzjifj">Substitution preference</legend>
        {options.map(option => <label key={option.id} className={`flex cursor-pointer items-start gap-3 rounded-lg border p-3 transition-colors duration-150 ${preference === option.id ? 'border-brand bg-brand-light' : 'border-brand-border hover:bg-gray-50'}`} data-id="element-4318" data-mp="14iq1hzudxwh">
            <input type="radio" name="substitution" value={option.id} checked={preference === option.id} onChange={() => setPreference(option.id)} className="mt-0.5 h-4 w-4 border-brand-border text-brand focus:ring-brand" data-id="element-4319" data-mp="a45hbayuxnbt" />
            <span data-id="element-4320" data-mp="3eiwxt6rg6ipu"><span className="block text-sm font-bold text-brand-ink" data-id="element-4321" data-mp="3eh2n0l9w46zh">{option.label}</span><span className="mt-0.5 block text-xs leading-4 text-brand-muted" data-id="element-4322" data-mp="1hhzr3i7blc3h">{option.description}</span></span>
          </label>)}
      </fieldset>
    </section>;
}